export default __webpack_public_path__ + "static/rovo-menu-dark-fc6c1ca9683e854cc7613031328f533d.png";